import * as React from 'react';

const SvgMiscGraph = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M13.5 4h-3v16h3V4ZM7.5 12h-3v8h3v-8ZM19.5 9h-3v11h3V9Z" })
);

export { SvgMiscGraph as default };
//# sourceMappingURL=MiscGraph.es.js.map
